type Messages = Record<string, string>;

const MESSAGE_LOADERS: Partial<Record<string, () => Promise<{ default: Messages }>>> = {
	de: () =>
		import(/* webpackChunkName: "@atlassian/twg-benchmarking-experience-i18n-de" */ '../i18n/de'),
	en: () =>
		import(/* webpackChunkName: "@atlassian/twg-benchmarking-experience-i18n-en" */ '../i18n/en'),
	en_GB: () =>
		import(
			/* webpackChunkName: "@atlassian/twg-benchmarking-experience-i18n-en_GB" */ '../i18n/en_GB'
		),
	en_ZZ: () =>
		import(
			/* webpackChunkName: "@atlassian/twg-benchmarking-experience-i18n-en_ZZ" */ '../i18n/en_ZZ'
		),
	es: () =>
		import(/* webpackChunkName: "@atlassian/twg-benchmarking-experience-i18n-es" */ '../i18n/es'),
	fr: () =>
		import(/* webpackChunkName: "@atlassian/twg-benchmarking-experience-i18n-fr" */ '../i18n/fr'),
	it: () =>
		import(/* webpackChunkName: "@atlassian/twg-benchmarking-experience-i18n-it" */ '../i18n/it'),
	ja: () =>
		import(/* webpackChunkName: "@atlassian/twg-benchmarking-experience-i18n-ja" */ '../i18n/ja'),
	ko: () =>
		import(/* webpackChunkName: "@atlassian/twg-benchmarking-experience-i18n-ko" */ '../i18n/ko'),
	nl: () =>
		import(/* webpackChunkName: "@atlassian/twg-benchmarking-experience-i18n-nl" */ '../i18n/nl'),
	pl: () =>
		import(/* webpackChunkName: "@atlassian/twg-benchmarking-experience-i18n-pl" */ '../i18n/pl'),
	pt_BR: () =>
		import(
			/* webpackChunkName: "@atlassian/twg-benchmarking-experience-i18n-pt_BR" */ '../i18n/pt_BR'
		),
	ru: () =>
		import(/* webpackChunkName: "@atlassian/twg-benchmarking-experience-i18n-ru" */ '../i18n/ru'),
	zh: () =>
		import(/* webpackChunkName: "@atlassian/twg-benchmarking-experience-i18n-zh" */ '../i18n/zh'),
};

const loadBundle = async (key: string): Promise<Messages | undefined> => {
	const loader = MESSAGE_LOADERS[key];
	if (loader === undefined) {
		return undefined;
	}
	return (await loader()).default;
};

/**
 * Loads this package's Traduki messages for a BCP-47 locale such as `pt-BR` or `ja-JP`, trying
 * the exact bundle first and then the language-only one.
 *
 * Resolves to `undefined` when this package ships no bundle for the locale. Rejects when a bundle
 * exists but fails to load, so the host can log it.
 */
export const loadMessages = async (locale: string): Promise<Messages | undefined> => {
	const key = locale.replace('-', '_');
	return (await loadBundle(key)) ?? loadBundle(key.split('_')[0]);
};
